import type { FC } from 'react';
import { useCallback } from 'react';

import { useModal } from '@mit/ui-components/right-tower';

import { PackCard } from '../PackCard';
import { PackModal } from '../PackModal';
import { StoreCardWrapper } from '../StoreCardWrapper';

import type { Bundle } from '@site-builder/store-sdk';

interface PackCardWithModalProps {
  readonly data: Bundle;
  readonly onPurchase?: () => void;
}

export const PackCardWithModal: FC<PackCardWithModalProps> = ({
  data,
  onPurchase,
}) => {
  const { isOpen, setIsOpen } = useModal({});

  const handleOpenModal = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const handleCloseModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <StoreCardWrapper item={data} onPurchase={onPurchase}>
      <div onClick={handleOpenModal} style={{ cursor: 'pointer' }}>
        <PackCard data={data} />
      </div>
      <PackModal isOpen={isOpen} onClose={handleCloseModal} packData={data} />
    </StoreCardWrapper>
  );
};
